import React from 'react';
import { Link } from 'react-router-dom';

const SiteBreadcrumb = (props) => {
    const { pageTitle, parentCategory, pageCategory, pageName } = props;

    // এই কম্পোনেন্ট আগে template-এর একটা placeholder ছবি ব্যবহার করত
    // (যেটার গায়ে আসলে বড় করে "1920X495" লেখা ছিল — বাস্তব কোনো ছবি না,
    // সব পেজের banner-এই সেটা দেখাচ্ছিল)। এখন brand রঙের gradient
    // ব্যবহার করা হচ্ছে, যাতে প্রতিটা পেজে সবসময় পরিষ্কার, professional
    // দেখায় — কোনো external ছবির উপর নির্ভর করতে হয় না।
    const breadcrumbsImgStyle = {
        backgroundImage: 'linear-gradient(120deg, #32003e 0%, #6a0f6b 45%, #fd60a2 100%)',
    }

    return (
        <>
            {/*Page Header Start*/}
            <section className="page-header">
                <div
                className="page-header__bg"
                style={breadcrumbsImgStyle}></div>
                <div className="container">
                <div className="page-header__inner">
                    <h2>{pageTitle ? pageTitle : 'Breadcrumbs'}</h2>
                    <div className="thm-breadcrumb__box">
                        <ul className="thm-breadcrumb list-unstyled">
                            <li>
                                <Link to="/" className="active">{parentCategory ? parentCategory : 'Home'}</Link>
                            </li>
                            <li><span className="icon-angle-left"></span></li>
                            {pageCategory ? (
                                <>
                                    <li>
                                        <Link to="/" className="active">{pageCategory}</Link>
                                    </li>
                                    
                                    <li>{pageName ? pageName : 'Page Name'}</li>
                                </>
                            ) : (
                                <li>{pageName ? pageName : 'Page Name'}</li>
                            )}
                        </ul>
                    </div>
                </div>
                </div>
            </section>
            {/*Page Header End*/}
        </>
    );
}

export default SiteBreadcrumb;
